/* eslint-disable no-param-reassign */
import { MutableRefObject } from 'react';

export function getCursorPosition<T extends HTMLInputElement | null>(
  inputRef: MutableRefObject<T>
): number {
  return inputRef.current?.selectionEnd || 0;
}

export function calcCursorPosition(
  inputValue: string,
  prevValue: string | undefined,
  formattedResult: { value: string; cursor: number }
): number {
  // если после изменения символов строка сформатиловалась как и была
  // то просто передвигаем курсор на кол-во измененных символов
  let { cursor } = formattedResult;
  const lengthDiff = inputValue.length - formattedResult.value.length;

  if (lengthDiff < 0) {
    if (cursor && prevValue === formattedResult.value) {
      cursor += lengthDiff;
    }
  } else if (lengthDiff > 0) {
    if (!cursor && prevValue === formattedResult.value) {
      cursor -= lengthDiff;
    }
  }

  return cursor;
}

export function moveCursorPosition<T extends HTMLInputElement | null>(
  inputRef: MutableRefObject<T>,
  cursorPosition: number
): void {
  if (inputRef.current) {
    inputRef.current.selectionStart = cursorPosition;
    inputRef.current.selectionEnd = cursorPosition;
  }
}
